import React, { useState } from "react";

import { useAuth } from "react-oidc-context";

import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import {
  Layout,
  Notification,
  UserMenu,
  MenuItemLink,
  useNotify,
} from "react-admin";

import { CrewMenu } from "./CrewMenu.js";
import { CrewAppBar } from "./CrewAppBar.js";
import { useThemeState } from "../../ThemeStateProvider.js";
import {
  AppInfoIcon,
  BugIcon,
  ContrastIcon,
  LogoutIcon,
  ProfileIcon,
  RoadmapIcon,
  ThemeToggleIcon,
} from "../../components/common/iconography.js";
import DefaultError from "../../components/DefaultError.js";
import { AppInfoDialog } from "../../components/common/AppInfoDialog.js";
import { MenuItemClickable } from "../../components/MenuItemClickable.js";
import { buildRoadmapUrl, ensureProduktlyToken } from "../../utils/produktlyUtils.js";

const CrewUserMenu = ({ toggleAppInfoOpen, ...props }) => {
  const auth = useAuth();
  const notify = useNotify();
  const [roadmapDialogOpen, setRoadmapDialogOpen] = useState(false);
  const { toggleContrast, togglePalette } = useThemeState();

  const handleBugReport = () => {
    window.open("https://transloads.co/submit-a-ticket/", "_blank");
  };

  const handleRoadmap = async () => {
    try {
      setRoadmapDialogOpen(true);
      const produktlyToken = await ensureProduktlyToken(auth.user?.access_token);
      window.open(buildRoadmapUrl(produktlyToken), "_blank");
    } catch (error) {
      console.error("Roadmap Sign-in Error:", error);
      notify("Failed to open Roadmap. Please try again.", "error");
    } finally {
      setRoadmapDialogOpen(false);
    }
  };

  return (
    <>
      <UserMenu label="USER" icon={<MoreVertIcon />}>
        <MenuItemLink
          to={false}
          primaryText={window.appUser?.fullName}
          leftIcon={<ProfileIcon />}
        />
        <MenuItemClickable
          primaryText="Theme"
          leftIcon={<ThemeToggleIcon />}
          clickHandler={togglePalette}
        />
        <MenuItemClickable
          primaryText="Contrast"
          leftIcon={<ContrastIcon />}
          clickHandler={toggleContrast}
        />
        <MenuItemClickable
          primaryText="App Info"
          leftIcon={<AppInfoIcon />}
          clickHandler={toggleAppInfoOpen}
        />
        <MenuItemClickable
          primaryText="Roadmap"
          leftIcon={<RoadmapIcon />}
          clickHandler={handleRoadmap}
        />
        <MenuItemClickable
          primaryText="Log a Ticket"
          leftIcon={<BugIcon />}
          clickHandler={handleBugReport}
        />
        <MenuItemLink
          to="/logout"
          primaryText="Logout"
          leftIcon={<LogoutIcon />}
        />
      </UserMenu>
      <Dialog
        open={roadmapDialogOpen}
        onClose={() => {}}
        aria-labelledby="roadmap-loading-title"
      >
        <DialogTitle id="roadmap-loading-title">
          Preparing to Open Roadmap
        </DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            minWidth={260}
            minHeight={120}
          >
            <CircularProgress size={32} />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

const CrewLayout = (props) => {
  const [appInfoOpen, setAppInfoOpen] = useState(false);
  const toggleAppInfoOpen = (_, reason) => {
    if (reason !== "backdropClick") setAppInfoOpen(!appInfoOpen);
  };
  const userMenu = <CrewUserMenu toggleAppInfoOpen={toggleAppInfoOpen} />;

  return (
    <>
      <Layout
        {...props}
        appBar={(props) => CrewAppBar(props, userMenu)}
        menu={CrewMenu}
        notification={Notification}
        error={DefaultError}
      />
      <AppInfoDialog isOpen={appInfoOpen} onClose={toggleAppInfoOpen} />
    </>
  );
};

export default CrewLayout;
